import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './DotAccordion.css';

const DotAccordion = ({ items = [], index = 0, parameters = {} }) => {
  const [activeKey, setActiveKey] = useState(index.toString());

  const toggleAccordion = (eventKey) => {
    setActiveKey(activeKey === eventKey ? eventKey : eventKey);
  };

  return (
    <div
      aria-label="Accordion text"
      className="rounded mb-0 ms-2 ms-lg-0"
      style={{ maxWidth: '600px' }}>
      <Accordion activeKey={activeKey}>
        <div className="position-relative">
          <div className="line-doc-item position-absolute" />
          {items?.length > 0 &&
            items.map((item, index) => (
              <Card key={index} className="border-0 bg-transparent mb-3">
                <Card.Header className="border-0 bg-transparent p-0">
                  <div className="d-flex align-items-center">
                    <button
                      role="button"
                      aria-label="Get more info"
                      onClick={() => toggleAccordion(index.toString())}
                      className="btn btn-link p-0 me-3 position-relative"
                      style={{ width: '22px', height: '22px', zIndex: 1 }}
                      aria-expanded={activeKey === index.toString() ? 'true' : 'false'}
                      aria-controls={`content-${index}`}>
                      <span className="position-absolute doc-item rounded-circle" />
                      <span
                        className="doc-into-item position-absolute  translate-middle rounded-circle"
                        style={{
                          border:
                            activeKey === index.toString()
                              ? '5px solid black'
                              : 'var(--corporative-yellow)',
                          borderRadius:
                            activeKey === index.toString()
                              ? '3px solid white'
                              : 'var(--corporative-yellow)'
                        }}>
                        {activeKey === index.toString() ? (
                          <></>
                        ) : (
                          <FontAwesomeIcon fontSize="18px" color="black" icon={faChevronDown} />
                        )}
                      </span>
                    </button>
                    <span className="mb-0 text-white lt-card-title">{item.value}</span>
                  </div>
                </Card.Header>
                <Accordion.Collapse eventKey={index.toString()}>
                  <Card.Body className="w-100 text-white ps-5  lt-card-subtitle">
                    <div className="dot-contain">
                      {item.description_value?.replace(
                        '-X-',
                        parseInt(parameters?.APRCHALLENGE?.value)
                      )}
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            ))}
        </div>
      </Accordion>
    </div>
  );
};

export default DotAccordion;
